/**
 * Gets the user's timezone offset in minutes.
 */
export const getTimezoneOffset = (): number => new Date().getTimezoneOffset();
